export default {
    env: process.env.REACT_APP_ENV,
    baseUrl: process.env.REACT_APP_BASE_URL,
    emailDomain: process.env.REACT_APP_EMAIL_DOMAIN,
};
